import script from "./ConceptoEdicionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConceptoEdicionModal.vue?vue&type=script&setup=true&lang=js"

import "./ConceptoEdicionModal.vue?vue&type=style&index=0&id=0555c78c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0555c78c"]])

export default __exports__